import { render, staticRenderFns } from "./EditingDFGuideText.vue?vue&type=template&id=4ab48a58&"
import script from "./EditingDFGuideText.vue?vue&type=script&lang=js&"
export * from "./EditingDFGuideText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports